<script>
import { h } from "vue";
import SecondaryPageLayout from "@/Layouts/SecondaryPageLayout.vue";

export default {
    layout: (_, page) =>
        h(SecondaryPageLayout, { title: "Privacy Policy" }, () => page),
};
</script>

<script setup>
import { Head } from "@inertiajs/vue3";
import LegalDocument from "@/Components/Brand/LegalDocument.vue";

defineProps({
    policy: String,
});
</script>

<template>
    <Head>
        <title>Privacy Policy | Gift Hero Wish Lists</title>
        <meta
            name="description"
            content="Read about the Gift Hero privacy policy"
        />
        <meta property="og:title" content="Gift Hero Privacy Policy" />
        <meta
            property="og:description"
            content="Read about the Gift Hero privacy policy"
        />
        <meta property="og:url" :content="route('policy.show')" />
        <link rel="canonical" :href="route('policy.show')" />
    </Head>

    <LegalDocument :html="policy" />
</template>
